import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import throttle from 'lodash/throttle';
import cloneDeep from 'lodash/cloneDeep';
import * as Sentry from '@sentry/nextjs';
import React, { useState, useCallback, useMemo, useRef } from 'react';
import { useMeasure } from 'react-use';
import Spreadsheet from '@/components/Spreadsheet';
import { ButtonV2 as Button } from '@/components/Button';
import ButtonList from '@/components/ButtonList';
import ModalHoc from '@/components/ModalHoc';
import { Header as OptionsListHeader } from '@/components/lists/Options';
import logger from '@/utils/logger';
import responsiveUtils from '@/utils/responsive';
import { isFormSection } from '@/utils/reporting/widgetQueries';
import { CODES as ERROR_CODES } from '@/components/Spreadsheet/errors';
import useEditingAreasState from '@/components/Editor/hooks/useEditingAreasState';
import useAbandonChanges from '@/components/ConfirmationPrompt/hooks/useAbandonChanges';
import Header from '../Header';
import Footer from '../Footer';
import Preview from '@/components/Editor/Preview';
import useWorkbook from '@/components/Editor/hooks/useWorkbook';
import { useToast } from '@/hooks/useToast';
import useSelections from './useSelections';
import useHeaderSelections from './useHeaderSelections';
import useHighlights from './useHighlights';
import CollectionsList from './CollectionsList';
import SelectionsList from './SelectionsList';
import SelectionsV2 from './SelectionsV2';
import styles from './styles.module.scss';
import modalStyles from '@/components/ModalHoc/styles.module.scss';
import displayModalStyles from '@/components/ModalHoc/stylesDisplay.module.scss';
import commonModalStyles from '@/components/ModalHoc/stylesQuestion.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var PlusSquareIcon = function PlusSquareIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H11V8C11 7.44772 11.4477 7 12 7Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.3572 3H13.6428C14.7266 2.99999 15.6007 2.99998 16.3086 3.05782C17.0375 3.11737 17.6777 3.24318 18.27 3.54497C19.2108 4.02433 19.9757 4.78924 20.455 5.73005C20.7568 6.32234 20.8826 6.96253 20.9422 7.69138C21 8.39925 21 9.27339 21 10.3572V13.6428C21 14.7266 21 15.6008 20.9422 16.3086C20.8826 17.0375 20.7568 17.6777 20.455 18.27C19.9757 19.2108 19.2108 19.9757 18.27 20.455C17.6777 20.7568 17.0375 20.8826 16.3086 20.9422C15.6008 21 14.7266 21 13.6428 21H10.3572C9.27339 21 8.39925 21 7.69138 20.9422C6.96253 20.8826 6.32234 20.7568 5.73005 20.455C4.78924 19.9757 4.02433 19.2108 3.54497 18.27C3.24318 17.6777 3.11737 17.0375 3.05782 16.3086C2.99998 15.6007 2.99999 14.7266 3 13.6428V10.3572C2.99999 9.27341 2.99998 8.39926 3.05782 7.69138C3.11737 6.96253 3.24318 6.32234 3.54497 5.73005C4.02433 4.78924 4.78924 4.02433 5.73005 3.54497C6.32234 3.24318 6.96253 3.11737 7.69138 3.05782C8.39926 2.99998 9.27341 2.99999 10.3572 3ZM7.85424 5.05118C7.24907 5.10062 6.90138 5.19279 6.63803 5.32698C6.07354 5.6146 5.6146 6.07354 5.32698 6.63803C5.19279 6.90138 5.10062 7.24907 5.05118 7.85424C5.00078 8.47108 5 9.26339 5 10.4V13.6C5 14.7366 5.00078 15.5289 5.05118 16.1458C5.10062 16.7509 5.19279 17.0986 5.32698 17.362C5.6146 17.9265 6.07354 18.3854 6.63803 18.673C6.90138 18.8072 7.24907 18.8994 7.85424 18.9488C8.47108 18.9992 9.26339 19 10.4 19H13.6C14.7366 19 15.5289 18.9992 16.1458 18.9488C16.7509 18.8994 17.0986 18.8072 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C18.8072 17.0986 18.8994 16.7509 18.9488 16.1458C18.9992 15.5289 19 14.7366 19 13.6V10.4C19 9.26339 18.9992 8.47108 18.9488 7.85424C18.8994 7.24907 18.8072 6.90138 18.673 6.63803C18.3854 6.07354 17.9265 5.6146 17.362 5.32698C17.0986 5.19279 16.7509 5.10062 16.1458 5.05118C15.5289 5.00078 14.7366 5 13.6 5H10.4C9.26339 5 8.47108 5.00078 7.85424 5.05118Z",
      fill: "#12131A"
    })]
  }));
};

PlusSquareIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const PREFIX = 'components: Editor: SelectionsModal:';
const MODAL_ID = 'selections-editor-modal';

const SelectionsModal = _ref => {
  let {
    onSubmit,
    widget,
    selections: initialSelections,
    labelsSelections: initialLabelsSelections,
    legendsSelections: initialLegendsSelections,
    activeSelectionsType: initialSelectionsType,
    isLabeled,
    strategy: selectionsStrategy = 'default',
    reportingWidget,
    workbookName,
    workbookData,
    workbookMeta,
    controls = {},
    onClose
  } = _ref;
  const {
    addToast: sendNotification
  } = useToast();
  const {
    activeSectionId,
    activeSectionEditingArea,
    activeEditingAreaMeta
  } = useEditingAreasState();
  const {
    0: mobileMainView,
    1: setMobileMainView
  } = useState('spreadsheet');
  const {
    descriptions = {},
    textOverrides = {},
    multiCollectionSelections,
    maxSelections: availableMaxSelections = {},
    multiCollectionMaximums = Infinity,
    selectionLimits = {},
    labelsSelectionsSupported = {},
    legendsSelectionsSupported = {}
  } = controls;
  const isLabelsSelectionsSupported = labelsSelectionsSupported[selectionsStrategy];
  const isLegendsSelectionsSupported = legendsSelectionsSupported[selectionsStrategy];
  const isMultiCollectionSelection = (multiCollectionSelections || []).includes(selectionsStrategy);
  const strategyMaxCollections = multiCollectionMaximums[selectionsStrategy] || Infinity;
  const maxSelections = availableMaxSelections[selectionsStrategy] || Infinity;
  const maximumCollections = isMultiCollectionSelection ? strategyMaxCollections : 1; // Setup containers

  const [containerEl, {
    width
  }] = useMeasure();
  const {
    workbook,
    sheetNames,
    isLoading,
    activeSpreadsheet,
    selectSpreadsheet // spreadsheetErrors,

  } = useWorkbook({
    workbookName,
    widget: reportingWidget,
    workbookSrc: workbookData,
    workbookFormatsSrc: workbookMeta.formats,
    workbookGridsSrc: workbookMeta.grids,
    workbookStylesSrc: workbookMeta.styles,
    workbookCellDataSrc: workbookMeta.cellData
  }); // Setup selection logic

  const {
    selections,
    publishableSelections,
    selectionCollections,
    invalidSelectionCollections,
    activeCollection,
    activeSelection,
    activeSelectionCellRef,
    isAddingNewSelection,
    updatedAt,
    hasUpdates,
    selectSelection,
    selectCollection,
    changeSelection,
    removeSelection,
    removeCollection,
    selectAddingNewSelection,
    resetActiveSelection,
    addCollection
  } = useSelections({
    containerEl: containerEl,
    initialSelections,
    initialSelectionIndex: activeEditingAreaMeta === null || activeEditingAreaMeta === void 0 ? void 0 : activeEditingAreaMeta.selectionIndex,
    labeled: isLabeled,
    workbook,
    maxCollections: maximumCollections,
    isMultiCollectionSelection,
    selectionLimits,
    maxSelections,
    selectionsStrategy
  }); // Setup header selection logic

  const {
    labelsSelections,
    legendsSelections,
    changeLabelsSelections,
    changeLegendsSelections
  } = useHeaderSelections({
    initialLabelsSelections,
    initialLegendsSelections
  });
  const {
    selections: gridSelections,
    colors: highlightColors
  } = useHighlights(selectionCollections, activeCollection, activeSelection, isMultiCollectionSelection, maximumCollections); // Layouts

  const isSingleColLayout = useMemo(() => responsiveUtils.isMediumOrSmaller(width), [width]);
  const isTwoColLayout = !isSingleColLayout;
  const showMainPreview = isTwoColLayout || mobileMainView === 'preview';
  const showMainSpreadsheet = isTwoColLayout || mobileMainView === 'spreadsheet';
  const showSidebarButtons = isTwoColLayout;
  const showFooterButtons = isSingleColLayout;
  const showSidebarViewButtons = isSingleColLayout;
  const selectionDescription = descriptions[selectionsStrategy] || descriptions.default || '';
  const selectionTextOverrides = textOverrides[selectionsStrategy] || textOverrides.default || ''; // Send valid selection change to change event

  const handleSelectionChange = useCallback(cellRefs => {
    if (cellRefs) changeSelection(cellRefs);
  }, [changeSelection]);
  const getPublishableState = useCallback(() => {
    return {
      selections: publishableSelections,
      labelsSelections: labelsSelections.publishableSelections,
      legendsSelections: legendsSelections.publishableSelections,
      selectionsLabeled: false,
      selectionsStrategy
    };
  }, [publishableSelections, labelsSelections.publishableSelections, legendsSelections.publishableSelections, selectionsStrategy]); // Handle submit to parent scope

  const handleSubmit = useCallback(() => {
    if (!selections) return;
    onSubmit(getPublishableState()); // Close modal

    typeof onClose === 'function' && onClose();
  }, [onSubmit, selections, getPublishableState, onClose]); // Clone widget and overwrite
  // unpublished user updates into
  // the active section

  const previewWidget = useMemo(() => {
    const clone = cloneDeep(widget);
    const activeSection = (clone.sections || {})[activeSectionId] || {
      config: {}
    };
    let previewUpdateTarget = activeSection.config || {}; // Update individual question if the
    // target section is a form component

    if (isFormSection(activeSection)) {
      // @ts-ignore
      const questions = (activeSection.config || {}).questions || [];
      previewUpdateTarget = questions.find(_ref2 => {
        let {
          id
        } = _ref2;
        return id === activeSectionEditingArea;
      }) || {};
    } // Apply user selection updates
    // to the active section


    Object.assign(previewUpdateTarget, getPublishableState()); // Hide accreditation

    clone.subscriptionActive = true; // Hide any widget headings

    clone.config = _objectSpread(_objectSpread({}, clone.config), {
      heading: '',
      subHeading: ''
    });
    clone.updatedAt = updatedAt;
    return clone;
  }, [widget, activeSectionId, activeSectionEditingArea, getPublishableState, updatedAt]); // Notify user of catostrophic render error

  const handleRenderError = useCallback(userErr => {
    logger.error(`${PREFIX} handleRenderError: ${userErr}`);
    sendNotification({
      type: 'error',
      description: userErr.userMessage || 'Unexpected error'
    });
    Sentry.captureException(Error(`${PREFIX}: failed to render spreadsheet ${userErr}`));
  }, [sendNotification]); // Notify user of any warnings related to their actions

  const hasActiveWarningMsg = useRef(false); // eslint-disable-next-line react-hooks/exhaustive-deps

  const handleSpreadsheetWarning = useCallback(throttle(userErr => {
    let errMessage = userErr.userMessage;

    if (userErr.code === ERROR_CODES.uneditableWorkbook) {
      errMessage = 'While selecting updates to workbook are discarded, please use data editor.';
    }

    if (userErr.userMessage && !hasActiveWarningMsg.current) {
      sendNotification({
        type: 'warning',
        description: errMessage
      });
      setTimeout(() => {
        hasActiveWarningMsg.current = false;
      }, 4500);
      hasActiveWarningMsg.current = true;
    }
  }, 400, {
    leading: true
  }), [sendNotification]); // Confirm user wants to close modal
  // if there are any unsaved changes

  useAbandonChanges({
    id: MODAL_ID,
    title: 'Are you sure you want to abandon your changes without saving?',
    // Immediately close if no updates
    hasUpdates: hasUpdates,
    // Close modal if user discards changes
    onCancel: onClose,
    // Submit changes if user confirms
    onConfirm: handleSubmit
  });

  if (isLabelsSelectionsSupported || isLegendsSelectionsSupported) {
    return /*#__PURE__*/_jsx(SelectionsV2, {
      containerRef: containerEl,
      previewWidget: previewWidget,
      reportingWidget: reportingWidget,
      workbook: workbook,
      workbookMeta: workbookMeta,
      activeSpreadsheet: activeSpreadsheet,
      activeCollection: activeCollection,
      activeSelection: activeSelection,
      activeSelectionCellRef: activeSelectionCellRef,
      isAddingNewSelection: isAddingNewSelection,
      activeSelectionsType: initialSelectionsType,
      labelsSelectionsSupported: isLabelsSelectionsSupported,
      labelsSelections: labelsSelections.selections,
      activeLabelsSelectionCellRef: labelsSelections.activeSelectionCellRef,
      legendsSelectionsSupported: isLegendsSelectionsSupported,
      legendsSelections: legendsSelections.selections,
      activeLegendsSelectionCellRef: legendsSelections.activeSelectionCellRef,
      selectionsStrategy: selectionsStrategy,
      selectionCollections: selectionCollections,
      invalidSelectionCollections: invalidSelectionCollections,
      gridSelections: gridSelections,
      highlightColors: highlightColors,
      sheetNames: sheetNames,
      controls: controls,
      isTwoColLayout: isTwoColLayout,
      isLoading: isLoading,
      updatedAt: updatedAt,
      onSpreadsheetError: handleRenderError,
      onChangeSelection: handleSelectionChange,
      onChangeLabelsSelection: changeLabelsSelections,
      onChangeLegendsSelection: changeLegendsSelections,
      onSpreadsheetWarn: handleSpreadsheetWarning,
      onAddCollection: addCollection,
      onRemoveSelection: removeSelection,
      onRemoveCollection: removeCollection,
      onSelectSelection: selectSelection,
      onSelectCollection: selectCollection,
      onSelectSpreadsheet: selectSpreadsheet,
      onChangeAddMode: selectAddingNewSelection,
      onResetActiveSelection: resetActiveSelection,
      onSubmit: handleSubmit
    });
  }

  const footerProps = {
    actions: /*#__PURE__*/_jsx(Button, {
      type: "button",
      variant: "primary",
      onClick: handleSubmit,
      children: "Save Selections"
    })
  };
  return /*#__PURE__*/_jsxs("div", {
    ref: containerEl,
    className: clsx(displayModalStyles.container, isTwoColLayout ? displayModalStyles['container--twoCols'] : ''),
    children: [/*#__PURE__*/_jsxs("aside", {
      className: clsx(displayModalStyles.sidebar, !isTwoColLayout ? '-pos-relative' : '' // For mobile view buttons
      ),
      children: [/*#__PURE__*/_jsx(Header, {
        heading: "Selections",
        className: "-p-none"
      }), /*#__PURE__*/_jsxs("div", {
        className: displayModalStyles.sidebar__main,
        children: [/*#__PURE__*/_jsxs("p", {
          className: clsx(commonModalStyles.subHeading, '-mb'),
          children: [selectionDescription, "."]
        }), isMultiCollectionSelection ? /*#__PURE__*/_jsx(CollectionsList, {
          collections: selectionCollections,
          invalids: invalidSelectionCollections,
          activeCollection: activeCollection,
          activeSelection: activeSelection,
          highlightColors: highlightColors,
          isAdding: isAddingNewSelection,
          textOverrides: {
            deleteCollectionButton: selectionTextOverrides.deleteCollectionButton,
            groupTitle: selectionTextOverrides.collectionGroupTitle
          },
          onRemoveSelection: (collectionIndex, selectionIndex) => {
            removeSelection(collectionIndex, selectionIndex);
          },
          onRemoveCollection: index => removeCollection(index),
          onActivateCollection: index => selectCollection(index),
          onActivateSelection: index => selectSelection(index),
          onChangeAddMode: adding => selectAddingNewSelection(adding)
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(OptionsListHeader, {
            headings: ['Selections'],
            hasRightIcon: true
          }), /*#__PURE__*/_jsx(SelectionsList, {
            selections: selectionCollections[0],
            maxSelections: maxSelections,
            invalidSelections: invalidSelectionCollections[0],
            activeSelection: activeSelection,
            highlightColors: highlightColors,
            collectionIndex: 0,
            sheetNames: sheetNames,
            isAdding: isAddingNewSelection,
            onRemoveSelection: index => removeSelection(0, index),
            onActivateSelection: index => selectSelection(index),
            onChangeAddMode: adding => selectAddingNewSelection(adding)
          })]
        }), isMultiCollectionSelection ? selectionCollections.every(collection => collection.length > 0) && /*#__PURE__*/_jsx(Button, {
          variant: "tertiary",
          size: "large",
          onClick: addCollection,
          className: "w-full -mt-xxlarge",
          rightIcon: /*#__PURE__*/_jsx(PlusSquareIcon, {}),
          children: selectionTextOverrides.addCollectionButton || 'Add Group'
        }) : /*#__PURE__*/_jsx(_Fragment, {})]
      }), showSidebarViewButtons ? /*#__PURE__*/_jsxs(ButtonList, {
        variant: "flat",
        className: clsx(styles.viewButtons, '-p-none'),
        children: [/*#__PURE__*/_jsx(Button, {
          size: "small",
          variant: "secondary",
          disabled: mobileMainView === 'spreadsheet',
          onClick: () => setMobileMainView('spreadsheet'),
          children: "Spreadsheet"
        }), /*#__PURE__*/_jsx(Button, {
          size: "small",
          variant: "secondary",
          disabled: mobileMainView === 'preview',
          onClick: () => setMobileMainView('preview'),
          children: "Preview"
        })]
      }) : /*#__PURE__*/_jsx(_Fragment, {}), showSidebarButtons ? /*#__PURE__*/_jsx(Footer, _objectSpread({}, footerProps)) : /*#__PURE__*/_jsx(_Fragment, {})]
    }), /*#__PURE__*/_jsxs("section", {
      className: displayModalStyles.main,
      children: [showMainPreview ? /*#__PURE__*/_jsx("div", {
        className: clsx(styles.preview, isTwoColLayout ? styles['preview--large'] : ''),
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(Preview, {
            elementId: "selections-widget-preview",
            className: styles.preview__canvas,
            widget: previewWidget,
            reportingWidget: reportingWidget,
            focusedSectionId: activeSectionId,
            workbookFile: workbook,
            workbookMeta: workbookMeta,
            isResolutionControlHidden: true,
            isResolutionGroupControlHidden: true,
            isPreviewContainerCollapsed: true,
            updatedAt: updatedAt
          })
        })
      }) : /*#__PURE__*/_jsx(_Fragment, {}), showMainSpreadsheet ? /*#__PURE__*/_jsx("div", {
        className: clsx(styles.spreadsheet, isTwoColLayout ? styles['spreadsheet--large'] : ''),
        children: isLoading ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsx(Spreadsheet, {
          data: workbook,
          meta: workbookMeta,
          selections: gridSelections,
          activeSelection: activeSelectionCellRef,
          activeSheetIndex: activeSpreadsheet,
          editable: false,
          addingNewSelection: isAddingNewSelection // errors={spreadsheetErrors}
          ,
          onSelect: cellRefs => {
            handleSelectionChange(cellRefs);
          },
          onSheetChange: selectSpreadsheet,
          onSelectionClick: (_, details) => {
            if (details) {
              const isNewCollection = details.collectionIndex !== activeCollection;
              selectCollection(details.collectionIndex);
              selectSelection(details.selectionIndex, isNewCollection);
            }
          },
          onError: handleRenderError,
          onWarn: handleSpreadsheetWarning
        })
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }), showFooterButtons ? /*#__PURE__*/_jsx(Footer, _objectSpread({}, footerProps)) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};

export default ModalHoc(SelectionsModal, {
  modalClass: modalStyles['container--big'],
  overlayclass: modalStyles['overlay--high'],
  hasCloseButton: false,
  closeOnEvent: false,
  closeOnOverlayClick: false
});